export default __webpack_public_path__ + "static/media/led1_stop.aa1da33f.svg";